import Hero from "@/components/Hero";
import AiProducts from "@/components/AiProducts";
import CostMeter from "@/components/CostMeter";
import AnimatedStats from "@/components/AnimatedStats";
import TrustedBy from "@/components/TrustedBy";
import Team from "@/components/Team";
import Work from "@/components/Work";
import CaseStudies from "@/components/CaseStudies";
import FAQ from "@/components/FAQ";
import ProcessBand from "@/components/ProcessBand";
import Contact from "@/components/Contact";

export default function HomePage() {
    return (
        <main className="bg-white text-[#0a0a0b]">
            <div className="flex min-h-dvh flex-col">
                <Hero />
                <AnimatedStats />
                <TrustedBy />
            </div>
            <CostMeter />
            <AiProducts />
            <Work />
            <CaseStudies />
            <Team />
            <FAQ />
            <ProcessBand />
            <Contact />
        </main>
    );
}
